import { render } from "./DataCell.vue?vue&type=template&id=2bc34c0b"
import script from "./DataCell.vue?vue&type=script&lang=js"
export * from "./DataCell.vue?vue&type=script&lang=js"

import "./DataCell.vue?vue&type=style&index=0&id=2bc34c0b&lang=scss"

import exportComponent from "../../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__